import styled, { css } from '@benzinga/themetron';

interface QueuedStoriesNotificationProps {
  right?: string;
  top?: string;
}

export const MoreItemsBanner = styled.div<QueuedStoriesNotificationProps>`
  ${({ right = '0', theme, top = '0' }) => css`
    background-color: ${theme.colors.brand};
    color: ${theme.colors.foregroundActive};
    cursor: pointer;
    font-family: 'nimbus-sans', 'helvetica', 'arial', sans-serif;
    height: 26px;
    left: 0;
    line-height: 25px;
    margin: auto;
    position: absolute;
    right: ${right}px;
    text-align: center;
    top: ${top}px;
  `}
`;

export const MoreItemsBubbleBanner = styled.div<QueuedStoriesNotificationProps>`
  ${({ right, theme, top }) => css`
    background-color: ${theme.colors.brand};
    border-radius: 10px;
    color: ${theme.colors.foregroundActive};
    cursor: pointer;
    font-family: nimbus-sans, helvetica, arial, sans-serif;
    left: 0;
    line-height: 20px;
    margin: auto;
    position: absolute;
    right: ${right ? `${right}px` : 0};
    text-align: center;
    user-select: none;
    width: 120px;
    top: ${top ? `${top}px` : `auto`};
    z-index: 20;
  `}
`;
